<p-table #ptable4 [value]="salesLeadItems"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [showCurrentPageReport]="paginator"
         [totalRecords]="totalSalesLeadItems"
         [paginator]="paginator"
         [loading]="loading"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
         sortMode="single"
         sortField="DOCDATE"
         sortOrder="-1"
         dataKey="DRID"
         selectionMode="single"
         [(selection)]="selectedSalesLeadItem"
         [resizableColumns]="true"
         [rowHover]="true"
         rowExpandMode="single"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width: 3rem">...</th>
      <th pResizableColumn pSortableColumn="DRNOTE" style="width: 10% !important">Комментарий <p-sortIcon field="DRNOTE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNUMBER" style="width: 6% !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCDATE" style="width: 5% !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10% !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="AUTHOR" style="width: 6% !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="CLIENTSNAME" style="width: auto !important">Заказчик <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCSUM" style="width: 6% !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PAYDSUM" style="width: 6% !important">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="SHIPSUM" style="width: 6% !important">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE1" style="width: 10% !important">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE2" style="width: 10% !important">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
    </tr>
    <tr>
      <th pResizableColumn style="width: 3rem">...</th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DRNOTE']" (input)="ptable4.filter($event.target.value, 'DRNOTE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNUMBER']" (input)="ptable4.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCDATE']" (input)="ptable4.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['LOCALCOMP']" (input)="ptable4.filter($event.target.value, 'LOCALCOMP', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['AUTHOR']" (input)="ptable4.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['CLIENTSNAME']" (input)="ptable4.filter($event.target.value, 'CLIENTSNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCSUM']" (input)="ptable4.filter($event.target.value, 'DOCSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['PAYDSUM']" (input)="ptable4.filter($event.target.value, 'PAYDSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['SHIPSUM']" (input)="ptable4.filter($event.target.value, 'SHIPSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNOTE1']" (input)="ptable4.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf4['DOCNOTE2']" (input)="ptable4.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-nsol let-expanded="expanded">
    <tr [pSelectableRow]="nsol"
        [class.futuredocs]="nsol.fd"
        [class.grayout]="nsol.go"
        [class.underline]="nsol.ps"
        [class.strikeout]="nsol.fs"
        [class.partiallypaiddoc]="nsol.pp"
        [class.notpaiddoc]="nsol.np"
        [class.fullypaiddoc]="nsol.fp"
        [class.todaydocuments]="nsol.td"
        [class.proformadoc]="(nsol.DOCTYPEID == 12)"
        [class.inorderdoc]="(nsol.DOCTYPEID == 2)"
        [class.banktransferdoc]="(nsol.DOCTYPEID == 9)"
        [class.purchorderdoc]="(nsol.DOCTYPEID == 10)"
        [class.yellowdoc]="(nsol.DOCTYPEID == 14)"
        [class.specdoc]="(nsol.DOCTYPEID == 7)"
        [class.shiporderdoc]="(nsol.DOCTYPEID == 4)"
        [class.invoicedoc]="(nsol.DOCTYPEID == 1)">
      <td>
        <button type="button" pButton pRipple [pRowToggler]="nsol"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
      </td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{nsol.DRNOTE}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', nsol.DOCTYPEID, nsol.DOCID]">{{nsol.DOCNUMBER}}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{nsol.DOCDATE  | date:'dd.MM.yyyy'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{nsol.LOCALCOMP}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{nsol.AUTHOR}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-client', nsol.DOCCLIENTSID]">{{nsol.CLIENTSNAME}}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{nsol.DOCSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{nsol.PAYDSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{nsol.SHIPSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{nsol.DOCNOTE1}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{nsol.DOCNOTE2}}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-nsol>
    <tr>
      <td colspan="12">
        <div class="p-p-2">
          <app-document-content-table [selectedDocumentId]="nsol.DOCID" [showFooterTotal]="true"></app-document-content-table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="12">Записей не обнаружено</td>
    </tr>
  </ng-template>
</p-table>
